module.exports = __webpack_public_path__ + "img/2.96dcb167.svg";